export default "__VITE_ASSET__C8ocjXnq__"